import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Laptop = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.022 67.699h71.957a4.978 4.978 0 0 0 4.976-4.977V18.628a4.976 4.976 0 0 0-4.976-4.976H14.022a4.976 4.976 0 0 0-4.976 4.976v44.094a4.976 4.976 0 0 0 4.976 4.977zm4.976-44.095h62.005v34.142H18.998V23.604zm76.327 49.082H4.675a2.294 2.294 0 0 0-2.294 2.294v5.555c0 .58.218 1.135.609 1.559l3.25 3.518a2.304 2.304 0 0 0 1.684.735h83.915c.612 0 1.198-.245 1.631-.681l3.485-3.519a2.3 2.3 0 0 0 .664-1.613V74.98a2.295 2.295 0 0 0-2.294-2.294zm-36.656 7.969c0 .28-.185.507-.415.507H41.746c-.23 0-.415-.227-.415-.507v-2.264c0-.28.185-.504.415-.504h16.508c.23 0 .415.224.415.504v2.264z"
  }));
});
Laptop.displayName = 'Laptop';
export var LaptopDimensions = {
  height: 100,
  width: 100
};